import { combineActions, handleActions } from 'redux-actions'
import {
  actionsTypesGenerator,
  onRequest,
  onSuccess,
  onFailure,
} from 'utils/reduxHelpers'
import initialState from '../initialState'

const namespace = 'PLAYER'

const FETCH_TEAM_PLAYERS = actionsTypesGenerator(`FETCH_TEAM_${namespace}S`)
const FETCH_TEAM_PLAYER = actionsTypesGenerator(`FETCH_TEAM_${namespace}`)
const CREATE_TEAM_PLAYER = actionsTypesGenerator(`CREATE_${namespace}`)
const UPDATE_PLAYER = actionsTypesGenerator(`UPDATE_${namespace}`)
const DELETE_PLAYER = actionsTypesGenerator(`DELETE_${namespace}`)
const CREATE_PLAYER_PHYSIQUE = actionsTypesGenerator(
  `CREATE_${namespace}_PHYSIQUE`
)
const UPDATE_PLAYER_PHYSIQUE = actionsTypesGenerator(
  `UPDATE_${namespace}_PHYSIQUE`
)
const DELETE_PLAYER_PHYSIQUE = actionsTypesGenerator(
  `DELETE_${namespace}_PHYSIQUE`
)
const CREATE_PLAYER_INJURY = actionsTypesGenerator(`CREATE_${namespace}_INJURY`)
const UPDATE_PLAYER_INJURY = actionsTypesGenerator(`UPDATE_${namespace}_INJURY`)
const DELETE_PLAYER_INJURY = actionsTypesGenerator(`DELETE_${namespace}_INJURY`)
const CREATE_PLAYER_NOTE = actionsTypesGenerator(`CREATE_${namespace}_NOTE`)
const UPDATE_PLAYER_NOTE = actionsTypesGenerator(`UPDATE_${namespace}_NOTE`)
const DELETE_PLAYER_NOTE = actionsTypesGenerator(`DELETE_${namespace}_NOTE`)
const CREATE_PLAYER_ANALYSIS = actionsTypesGenerator(
  `CREATE_${namespace}_ANALYSIS`
)
const UPDATE_PLAYER_ANALYSIS = actionsTypesGenerator(
  `CREATE_${namespace}_ANALYSIS`
)
const DELETE_PLAYER_ANALYSIS = actionsTypesGenerator(
  `DELETE_${namespace}_ANALYSIS`
)
const UPDATE_PLAYER_AVATAR = actionsTypesGenerator(`UPDATE_${namespace}_AVATAR`)
const UPDATE_AVATAR = actionsTypesGenerator(`UPDATE_${namespace}_AVATAR`)
const INVITE_USER_FOR_PLAYER = actionsTypesGenerator(`INVITE_${namespace}`)
const DEACTIVATE_PLAYER = actionsTypesGenerator('DEACTIVATE_PLAYER')
const FETCH_PLAYER_TRANSFER_DESTINATIONS = actionsTypesGenerator(
  'FETCH_PLAYER_TRANSFER_DESTINATIONS'
)
const TRANSFER_PLAYER = actionsTypesGenerator('TRANSFER_PLAYER')
const UPDATE_PLAYER_PAUSE_STATUS = 'UPDATE_PLAYER_PAUSE_STATUS'

export const updatePlayerPauseStatus = (playerUuid, pauseData) => {
  return {
    type: 'UPDATE_PLAYER_PAUSE_STATUS',
    payload: {
      playerUuid,
      pauseData,
    },
  }
}

export const fetchTeamPlayers = (teamUuid, params) => ({
  types: FETCH_TEAM_PLAYERS,
  callAPI: {
    method: 'GET',
    entity: 'Players',
    path: `/v2/teams/${teamUuid}/players`,
    params,
  },
})

export const fetchTeamPlayer = (playerId, params) => ({
  types: FETCH_TEAM_PLAYER,
  callAPI: {
    method: 'GET',
    entity: 'Player',
    path: `/players/${playerId}`,
    params,
  },
})

export const createTeamPlayer = (teamUuid, data) => ({
  types: CREATE_TEAM_PLAYER,
  callAPI: {
    method: 'POST',
    entity: 'Player',
    path: `/v2/teams/${teamUuid}/players`,
    data,
  },
})

export const updatePlayer = (playerUuid, data) => ({
  types: UPDATE_PLAYER,
  callAPI: {
    method: 'PATCH',
    entity: 'Player',
    path: `/v2/players/${playerUuid}`,
    data,
  },
})

export const deletePlayer = (playerUuid) => ({
  types: DELETE_PLAYER,
  callAPI: {
    method: 'DELETE',
    entity: 'Player',
    path: `/v2/players/${playerUuid}`,
  },
  payload: { id: playerUuid },
})

export const createPlayerPhysique = (playerUuid, data) => ({
  types: CREATE_PLAYER_PHYSIQUE,
  callAPI: {
    method: 'POST',
    entity: 'Player',
    path: `/v2/players/${playerUuid}/physiques`,
    data,
  },
})

export const updatePlayerPhysique = (physiqueUuid, data) => ({
  types: UPDATE_PLAYER_PHYSIQUE,
  callAPI: {
    method: 'PATCH',
    entity: 'Player',
    path: `/v2/player-physiques/${physiqueUuid}`,
    data,
  },
})

export const deletePlayerPhysique = (physiqueUuid) => ({
  types: DELETE_PLAYER_PHYSIQUE,
  callAPI: {
    method: 'DELETE',
    entity: 'Player',
    path: `/v2/player-physiques/${physiqueUuid}`,
  },
})

export const createPlayerInjury = (playerUuid, data) => ({
  types: CREATE_PLAYER_INJURY,
  callAPI: {
    method: 'POST',
    entity: 'Player',
    path: `/v2/players/${playerUuid}/injuries`,
    data,
  },
})

export const updatePlayerInjury = (injuryUuid, data) => ({
  types: UPDATE_PLAYER_INJURY,
  callAPI: {
    method: 'PATCH',
    entity: 'Player',
    path: `/v2/player-injuries/${injuryUuid}`,
    data,
  },
})

export const deletePlayerInjury = (injuryUuid) => ({
  types: DELETE_PLAYER_INJURY,
  callAPI: {
    method: 'DELETE',
    entity: 'Player',
    path: `/v2/player-injuries/${injuryUuid}`,
  },
})

export const createPlayerNote = (playerUuid, data) => ({
  types: CREATE_PLAYER_NOTE,
  callAPI: {
    method: 'POST',
    entity: 'Player',
    path: `/v2/players/${playerUuid}/notes`,
    data,
  },
})

export const updatePlayerNote = (noteUuid, data) => ({
  types: UPDATE_PLAYER_NOTE,
  callAPI: {
    method: 'PATCH',
    entity: 'Player',
    path: `/v2/player-notes/${noteUuid}`,
    data,
  },
})

export const deletePlayerNote = (noteUuid) => ({
  types: DELETE_PLAYER_NOTE,
  callAPI: {
    method: 'DELETE',
    entity: 'Player',
    path: `/v2/player-notes/${noteUuid}`,
  },
})

export const createPlayerAnalysis = (playerUuid, data) => ({
  types: CREATE_PLAYER_ANALYSIS,
  callAPI: {
    method: 'POST',
    entity: 'Player Analysis',
    path: `/v2/players/${playerUuid}/analysis`,
    data,
  },
})

export const updatePlayerAnalysis = (analysisUuid, data) => ({
  types: UPDATE_PLAYER_ANALYSIS,
  callAPI: {
    method: 'PATCH',
    entity: 'Player Analysis',
    path: `/v2/player-analysis/${analysisUuid}`,
    data,
  },
})

export const deletePlayerAnalysis = (analysisUuid) => ({
  types: DELETE_PLAYER_ANALYSIS,
  callAPI: {
    method: 'DELETE',
    entity: 'Player Analysis',
    path: `/v2/player-analysis/${analysisUuid}`,
  },
})

export const sendInvitations = (teamId, data) => ({
  types: INVITE_USER_FOR_PLAYER,
  callAPI: {
    method: 'POST',
    entity: 'User invites',
    path: `/team/${teamId}/users/invite`,
    data,
  },
})

export const deactivatePlayer = (playerUuid) => ({
  types: DEACTIVATE_PLAYER,
  callAPI: {
    method: 'POST',
    entity: 'Player Archive',
    path: `/v2/players/${playerUuid}/deactivate`,
  },
})

export const fetchPlayerTransferDestinations = (playerUuid) => ({
  types: FETCH_PLAYER_TRANSFER_DESTINATIONS,
  callAPI: {
    method: 'GET',
    path: `/v2/players/${playerUuid}/transfer-destinations`,
    data: {
      preventToastNotification: true,
    },
  },
})

export const transferPlayer = (playerUuid, data) => ({
  types: TRANSFER_PLAYER,
  callAPI: {
    method: 'POST',
    entity: 'Player transfer',
    path: `/v2/players/${playerUuid}/transfer`,
    data,
  },
})

// Update player avatar
export const setPlayerAvatar = (avatar) => ({
  type: UPDATE_AVATAR,
  payload: avatar,
})

export default handleActions(
  {
    [combineActions(
      FETCH_TEAM_PLAYERS.request,
      FETCH_TEAM_PLAYER.request,
      UPDATE_PLAYER.request,
      DELETE_PLAYER.request,
      CREATE_PLAYER_PHYSIQUE.request,
      UPDATE_PLAYER_PHYSIQUE.request,
      DELETE_PLAYER_PHYSIQUE.request,
      CREATE_PLAYER_INJURY.request,
      UPDATE_PLAYER_INJURY.request,
      DELETE_PLAYER_INJURY.request,
      CREATE_PLAYER_NOTE.request,
      UPDATE_PLAYER_NOTE.request,
      DELETE_PLAYER_NOTE.request,
      CREATE_PLAYER_ANALYSIS.request,
      DELETE_PLAYER_ANALYSIS.request,
      DELETE_PLAYER_ANALYSIS.request,
      UPDATE_PLAYER_AVATAR.request,
      CREATE_TEAM_PLAYER.request,
      INVITE_USER_FOR_PLAYER.request,
      DEACTIVATE_PLAYER.request,
      FETCH_PLAYER_TRANSFER_DESTINATIONS.request,
      TRANSFER_PLAYER.request,
      UPDATE_AVATAR.request
    )]: onRequest,
    [FETCH_TEAM_PLAYERS.success]: (state, { response }) => {
      const { data = [] } = response

      return onSuccess({
        ...state,
        items: data,
      })
    },
    [FETCH_TEAM_PLAYER.success]: (state, { response }) => {
      const { data = {} } = response

      return onSuccess({
        ...state,
        current: data,
      })
    },
    [combineActions(
      CREATE_TEAM_PLAYER.success,
      CREATE_PLAYER_NOTE.success,
      CREATE_PLAYER_INJURY.success,
      CREATE_PLAYER_PHYSIQUE.success,
      CREATE_PLAYER_ANALYSIS.success,
      UPDATE_PLAYER_NOTE.success,
      UPDATE_PLAYER_PHYSIQUE.success,
      UPDATE_PLAYER_INJURY.success
    )]: (state, { response }) => {
      const { data = {} } = response

      return onSuccess({
        ...state,
        items: [data, ...state.items],
      })
    },
    [UPDATE_AVATAR]: (state, { payload }) => ({
      ...state,
      current: { ...state.current, avatar: payload },
    }),
    [combineActions(
      UPDATE_PLAYER.success,
      UPDATE_PLAYER_AVATAR.success
    )]: (state, { response }) => {
      const { data = {} } = response
      const { uuid } = data
      const items = state.items.updateByUuid(uuid, { ...data, isNew: false })

      return onSuccess({
        ...state,
        items,
        current: { ...state.current, ...data },
      })
    },
    [combineActions(
      DELETE_PLAYER.success,
      DELETE_PLAYER_PHYSIQUE.success,
      DELETE_PLAYER_INJURY.success,
      DELETE_PLAYER_NOTE.success,
      UPDATE_PLAYER_ANALYSIS.success,
      DELETE_PLAYER_ANALYSIS.success
    )]: (state, { id }) =>
      onSuccess({ ...state, items: state.items.filterByUuid(id) }),
    [DEACTIVATE_PLAYER.success]: (state, { response: { data } }) => {
      const { uuid } = data
      const items = state.items.updateByUuid(uuid, { ...data })

      return onSuccess({
        ...state,
        items,
      })
    },
    [FETCH_PLAYER_TRANSFER_DESTINATIONS.success]: (
      state,
      { response: { data } }
    ) => {
      return onSuccess({
        ...state,
      })
    },
    [TRANSFER_PLAYER.success]: (state, { response: { data } }) => {
      const { uuid } = data
      const items = state.items.updateByUuid(uuid, { ...data })

      return onSuccess({
        ...state,
        items,
      })
    },
    [UPDATE_PLAYER_PAUSE_STATUS]: (state, { payload }) => {
      return {
        ...state,
        items: state.items.updateByUuid(payload.playerUuid, payload.pauseData),
      }
    },
    [combineActions(
      FETCH_TEAM_PLAYERS.failure,
      FETCH_TEAM_PLAYER.failure,
      CREATE_TEAM_PLAYER.failure,
      UPDATE_PLAYER.failure,
      UPDATE_PLAYER_AVATAR.failure,
      DELETE_PLAYER.failure,
      CREATE_PLAYER_PHYSIQUE.failure,
      UPDATE_PLAYER_PHYSIQUE.failure,
      DELETE_PLAYER_PHYSIQUE.failure,
      CREATE_PLAYER_INJURY.failure,
      UPDATE_PLAYER_INJURY.failure,
      DELETE_PLAYER_INJURY.failure,
      CREATE_PLAYER_NOTE.failure,
      UPDATE_PLAYER_NOTE.failure,
      DELETE_PLAYER_NOTE.failure,
      CREATE_PLAYER_ANALYSIS.failure,
      UPDATE_PLAYER_ANALYSIS.failure,
      DELETE_PLAYER_ANALYSIS.failure,
      INVITE_USER_FOR_PLAYER.failure,
      DEACTIVATE_PLAYER.failure,
      FETCH_PLAYER_TRANSFER_DESTINATIONS.failure,
      TRANSFER_PLAYER.failure
    )]: onFailure,
  },
  initialState.players
)
